module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVQAAAA8CAYAAAA5QkI2AAAABHNCSVQICAgIfAhkiAAAAGZJREFUeJztwTEBAAAAwqD1T20MH6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/gY/CwABclftjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/toum.png
// module id = /M8i
// module chunks = 1